import * as menuBoard from "../lib/api/menuBoard";
import * as menuBoardBadge from "../enums/menuBoardBadge";
import AlertModal from "./AlertModal";
import PropTypes from "prop-types";
import StyledDropdown from "./StyledDropdown";
import React, { PureComponent } from "react";
import {
    Button,
    Checkbox,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    Modal,
    Row,
} from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";

const strings = {
    itemGrouping: "Item/Grouping",
    plu: "PLU",
    dmbName: "DMB Name",
    dmbBadge: "Badge",
    dmbDescription: "DMB Description",
    showDisclaimer: "Show Disclaimer",
    none: "None",
};

const styles = StyleSheet.create({
    buttonRow: {
        display: "flex",
        flexDirection: "row",
        gap: "16px",
        justifyContent: "center",
    },
    topRow: {
        marginBottom: "16px",
    },
});

export default class AddEditMenuBoardItemModal extends PureComponent {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onSaveCallback: PropTypes.func.isRequired,
        handleClose: PropTypes.func.isRequired,
        itemGrouping: PropTypes.string.isRequired,
        plu: PropTypes.number.isRequired,
        dmbName: PropTypes.string,
        dmbBadge: PropTypes.string,
        dmbDescription: PropTypes.string,
        showDisclaimer: PropTypes.bool,
        menuName: PropTypes.string.isRequired,
        sectionId: PropTypes.string,
        itemId: PropTypes.string,
        groupingId: PropTypes.string,
        productId: PropTypes.string,
    };

    state = {
        itemGrouping: this.props.itemGrouping,
        plu: this.props.plu,
        dmbName: this.props.dmbName ? this.props.dmbName : "",
        dmbBadge: this.props.dmbBadge ? this.props.dmbBadge : menuBoardBadge.none.value,
        dmbDescription: this.props.dmbDescription ? this.props.dmbDescription : "",
        menuName: this.props.menuName,
        showDisclaimer: !!this.props.showDisclaimer,
        showAlertModal: false,
        alertMessage: "",
    };

    _onItemGroupingChange = e => {
        this.setState({ itemGrouping: e.target.value });
    };

    _onPluChange = e => {
        this.setState({ plu: e.target.value });
    };

    _onDmbNameChange = e => {
        this.setState({ dmbName: e.target.value });
    };

    _handleChangeBadgeDropdown = value => {
        this.setState({ dmbBadge: value });
    };

    _onDmbDescriptionChange = e => {
        this.setState({ dmbDescription: e.target.value });
    };

    _handleChangeShowDisclaimerCheckbox = () => {
        this.setState(prevState => ({ showDisclaimer: !prevState.showDisclaimer }));
    };

    _updateInfo = () => {
        if (this.props.productId) {
            // Edit
            menuBoard
                .updateMenuBoardCategoryProduct(this.props.productId, {
                    menuBoardName:
                        this.state.dmbName === this.props.dmbName ? null : this.state.dmbName,
                    menuBoardDescription:
                        this.state.dmbDescription === this.props.dmbDescription
                            ? null
                            : this.state.dmbDescription,
                    badge: this.state.dmbBadge === this.props.dmbBadge ? null : this.state.dmbBadge,
                    showDisclaimer:
                        this.state.showDisclaimer === this.props.showDisclaimer
                            ? null
                            : this.state.showDisclaimer,
                })
                .then(() => {
                    this.props.onSaveCallback({
                        id: this.props.productId,
                        plu: this.props.plu,
                        productName: this.props.itemGrouping,
                        menuBoardName: this.state.dmbName,
                        menuBoardDescription: this.state.dmbDescription,
                        badge: this.state.dmbBadge,
                        showDisclaimer: this.state.showDisclaimer,
                    });
                })
                .catch(error => {
                    this.setState({
                        showAlertModal: true,
                        alertMessage: error.response.data,
                    });
                });
        } else {
            // Add
            menuBoard
                .addMenuBoardCategoryProduct(this.props.sectionId, {
                    itemId: this.props.itemId,
                    groupingId: this.props.groupingId,
                    menuBoardName: this.state.dmbName,
                    menuBoardDescription: this.state.dmbDescription,
                    badge: this.state.dmbBadge,
                    showDisclaimer: this.state.showDisclaimer,
                })
                .then(addedProduct => {
                    this.props.onSaveCallback(addedProduct.data);
                })
                .catch(error => {
                    this.setState({
                        showAlertModal: true,
                        alertMessage: error.response.data,
                    });
                });
        }
    };

    _hideAlertModal = () => {
        this.setState({
            showAlertModal: false,
        });
    };

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Menu Board - {this.state.menuName} - Edit Item/Grouping
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className={css(styles.topRow)}>
                        <Col md={6}>
                            <h5>{strings.itemGrouping}</h5>
                            <div className="m-b">{this.props.itemGrouping}</div>
                        </Col>
                        <Col md={6}>
                            <h5>{strings.plu}</h5>
                            <div className="m-b">{this.props.plu}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup controlId="dmbName">
                                <ControlLabel>{strings.dmbName}</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.dmbName}
                                    onChange={this._onDmbNameChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup controlId="dmbBadge" className={css(styles.flex1)}>
                                <ControlLabel>{strings.dmbBadge}</ControlLabel>
                                <StyledDropdown
                                    id="dmbBadge"
                                    value={this.state.dmbBadge}
                                    onChange={this._handleChangeBadgeDropdown}
                                    options={menuBoardBadge.dmbBadgeOptions}
                                    placeholder={strings.none}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup controlId="dmbDescription">
                                <ControlLabel>{strings.dmbDescription}</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.dmbDescription}
                                    onChange={this._onDmbDescriptionChange}
                                    componentClass="textarea"
                                    rows={3}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Checkbox
                                    checked={this.state.showDisclaimer}
                                    onChange={this._handleChangeShowDisclaimerCheckbox}
                                >
                                    {strings.showDisclaimer}
                                </Checkbox>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className={css(styles.buttonRow)}>
                        <Button bsStyle="link" onClick={this.props.handleClose}>
                            Cancel
                        </Button>
                        <Button
                            bsStyle="primary"
                            onClick={this._updateInfo}
                            disabled={
                                this.state.dmbName.length === 0 ||
                                this.state.dmbDescription.length === 0
                            }
                        >
                            Save
                        </Button>
                    </Row>
                </Modal.Body>
                <AlertModal
                    show={this.state.showAlertModal}
                    alertMessage={this.state.alertMessage}
                    handleClose={this._hideAlertModal}
                />
            </Modal>
        );
    }
}
